module.exports = __webpack_public_path__ + "static/media/chrome-river.02d9f6bb.jpg";